var exports = {
  "vK": "ReportFlowBanner.module__banner___d1BacT",
  "Kk": "ReportFlowBanner.module__icon___d1BacT",
  "Qq": "ReportFlowBanner.module__text___d1BacT",
};

module.exports = exports;
